/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Forgot_SubmittingInputs */

const es_co2_password_forgot_submitting = /** @type {(inputs: Password_Forgot_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

/**

* @param {Password_Forgot_SubmittingInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const password_forgot_submitting = /** @type {((inputs?: Password_Forgot_SubmittingInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Forgot_SubmittingInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_password_forgot_submitting(inputs)
});